module.exports = __webpack_public_path__ + "media/images/pc/stores/kyoto/kyoto_concept_04-315e87a121a6f1438877059f71d38b77.jpg";